var map = {
	"./../cafe/cafe.module": [
		"./src/app/cafe/cafe.module.ts",
		"default~cafe-cafe-module~cfg-cfg-module~cfgcafe-cfgcafe-module~freport-freport-module~layout-layout-~790421c2",
		"default~cafe-cafe-module~cfg-cfg-module~cfgcafe-cfgcafe-module~freport-freport-module",
		"default~cafe-cafe-module~cfg-cfg-module~cfgcafe-cfgcafe-module",
		"default~cafe-cafe-module~cfgcafe-cfgcafe-module",
		"cafe-cafe-module"
	],
	"./../cfg/cfg.module": [
		"./src/app/cfg/cfg.module.ts",
		"default~cafe-cafe-module~cfg-cfg-module~cfgcafe-cfgcafe-module~freport-freport-module~layout-layout-~790421c2",
		"default~cafe-cafe-module~cfg-cfg-module~cfgcafe-cfgcafe-module~freport-freport-module",
		"default~cafe-cafe-module~cfg-cfg-module~cfgcafe-cfgcafe-module",
		"cfg-cfg-module"
	],
	"./../cfgcafe/cfgcafe.module": [
		"./src/app/cfgcafe/cfgcafe.module.ts",
		"default~cafe-cafe-module~cfg-cfg-module~cfgcafe-cfgcafe-module~freport-freport-module~layout-layout-~790421c2",
		"default~cafe-cafe-module~cfg-cfg-module~cfgcafe-cfgcafe-module~freport-freport-module",
		"default~cafe-cafe-module~cfg-cfg-module~cfgcafe-cfgcafe-module",
		"default~cafe-cafe-module~cfgcafe-cfgcafe-module",
		"cfgcafe-cfgcafe-module"
	],
	"./../freport/freport.module": [
		"./src/app/freport/freport.module.ts",
		"default~cafe-cafe-module~cfg-cfg-module~cfgcafe-cfgcafe-module~freport-freport-module~layout-layout-~790421c2",
		"default~cafe-cafe-module~cfg-cfg-module~cfgcafe-cfgcafe-module~freport-freport-module",
		"freport-freport-module"
	],
	"./layout/layout.module": [
		"./src/app/layout/layout.module.ts",
		"default~cafe-cafe-module~cfg-cfg-module~cfgcafe-cfgcafe-module~freport-freport-module~layout-layout-~790421c2",
		"layout-layout-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;